module.exports = __webpack_public_path__ + "static/media/zen.7008c024.jpg";